import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  LaborManagerCreateActions,
  IsCTSEmployeeActions,
  UiActions
} from '../../../store/actions';
import { DataClientService } from '../../../services/data-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LabourData, RequestLaborManagerCreate } from 'src/app/shared/interfaces';
import { ApiResponseStatus, StepsClientTypes, StepsNotClientTypes, activitiesCodes } from '../../../shared/enums';
import { jobTitles } from '../data/jobTitles';
import { DatePipe } from '@angular/common';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { AccountFormatService } from 'src/app/services/account-format.service';
import { environment } from 'src/environments/environment';
import { DataNotClientService } from 'src/app/services/data-not-client.service';
import { Subscription } from 'rxjs';
import { LabourHandler } from '../labour-information/handler/labour.handler';
@Component({
  selector: 'app-labour-information-joint',
  templateUrl: './labour-information-joint.component.html',
  styleUrls: ['../../../global.scss', './labour-information-joint.component.scss']
})
export class LabourInformationJointComponent implements OnInit, OnDestroy {
  accountType: string;
  isCTS = false;
  jobTitles: any = jobTitles;
  formData: FormGroup;
  today: string;
  dateInvalid: boolean;
  privateMode: boolean;
  dataService: DataClientService | DataNotClientService;

  // Controles para mostrar o no un input
  showRuc: boolean;
  showDate: boolean;
  showProfession: boolean;
  showCompanyName: boolean;
  showSalaryCheck: boolean;

  // Controles para mostrar "Opcional"
  showOptionalRucLabel: boolean;
  showOptionalCompanyNameLabel: boolean;
  showOptionalProfessionLabel: boolean;
  showOptionalDateLabel: boolean;

  // Guardado de datos locales
  formRuc: AbstractControl;
  formDate: AbstractControl;
  formProfession: AbstractControl;
  formCompanyName: AbstractControl;
  formActivityType: AbstractControl;

  staticAssetsUrl = environment.staticScripts.staticAssets;

  subs = new Subscription();
  activities: any;
  activities$: LabourData[];
  ctsNewActivities: any;
  ctsDefaultValue: any = {
    codigo: null,
    nombre: ''
  };

  laborManagerCreate$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.laborManagerCreate)
  );

  isCTSEmployeeSuscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.isCTSEmployee)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataClientService: DataClientService,
    private dataNotClientService: DataNotClientService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private accountFormatService: AccountFormatService,
    private labourHandler: LabourHandler
  ) {
    this.accountType = this.accountFormatService.getName();
    this.setFormOptional();
  }

  laborManagerCreateSuscription = this.laborManagerCreate$.subscribe(({ response, error }) => {
    // error case
    if (error !== null) {
      this.store.dispatch(LaborManagerCreateActions.cleanState());
      if (this.privateMode) {
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      } else {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
      }
      this.loadingService.loading = false;
    }

    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK &&
          response.joint.operationState.code === ApiResponseStatus.OK) {
        this.store.dispatch(LaborManagerCreateActions.cleanState());
        if (this.privateMode) {
          this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_INFORMATION_PEP }));
        } else {
          this.store.dispatch(UiActions.Navigate({step: StepsNotClientTypes.STEP_NATIONALITY}));
        }
      }
    }
  });

  isCTSEmployeeSuscription = this.isCTSEmployeeSuscription$.subscribe(({ response, error }) => {
    if (error !== null) {
      this.store.dispatch(IsCTSEmployeeActions.cleanState());
    }

    // Empleado existe
    if (response) {
      if (response.joint.operationState.code === '00' && response.joint.data.employee) {
        this.isCTS = true;
        this.dataService.setIsCTS(this.isCTS);
        this.formData.get('workActivityType').setValue(activitiesCodes.DEPENDIENTE);
        this.formData.get('workActivityType').disable();
        setTimeout(() => {
          this.formData.get('companyName').setValue(response.joint.data.employee.enterprise.name);
          this.formData.get('dateEntryWork').setValue(this.datePipe.transform(response.joint.data.employee.dateOfAdmission, 'yyyy-MM-dd'));
          this.formData.get('rucCompany').setValue(response.joint.data.employee.enterprise.document.documentNumber);
          this.formData.get('companyName').disable();
          this.formData.controls['dateEntryWork'].disable();
          this.formData.controls['rucCompany'].disable();
          this.formData.setErrors({invalid: true});
        }, 10);
        this.loadingService.loading = false;
        this.activityChange();
      }
      this.store.dispatch(IsCTSEmployeeActions.cleanState());
    }
  });

  ngOnInit() {
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.subs.add(this.labourHandler.getActivities().subscribe((data) => {
      this.activities$ = data.newActivities;
      if (this.accountType === 'CTS') {
        this.ctsDefaultValue = this.activities$.find((activity) => activity.nombre === 'Dependiente');
        this.ctsNewActivities = this.activities$.filter((activity) => activity.nombre !== 'Dependiente');
        this.setFormRequired(this.ctsDefaultValue.codigo);
      } else {
        this.setFormOptional();
      }
      this.activities = this.accountType === 'CTS' ? this.ctsNewActivities : this.activities$;
    }));
    this.setService();
    this.today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    // TODO -> Llamar con datos main + mancomunado
    // this.store.dispatch(IsCTSEmployeeActions.getIsCTSEmployee());
    if (this.accountType === 'CTS') {
      this.showRuc = true;
      this.showDate = true;
      this.showCompanyName = true;
      this.showProfession = true;
    }
  }

  ngOnDestroy() {
    this.isCTSEmployeeSuscription.unsubscribe();
    this.laborManagerCreateSuscription.unsubscribe();
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = {is_joint_account: this.dataService.isIsJointAccount()};
    this.store.dispatch(TagPage({text: 'job-information-joint', extras: googleAnalytics}));
  }

  continue() {
    this.formActivityType = this.formData.controls['workActivityType'];
    this.formDate = this.formData.controls['dateEntryWork'];
    this.formCompanyName = this.formData.controls['companyName'];
    this.formRuc = this.formData.controls['rucCompany'];
    this.formProfession = this.formData.controls['profession'];

    this.callLaborManager();
  }

  callLaborManager() {
    this.setServiceData();
    const request: RequestLaborManagerCreate = {
      client: {
        workActivityType: this.dataService.getWorkActivityType()
      },
      joint: {
        workActivityType: this.dataService.getWorkActivityTypeJoint()
      }
    };
    // Chequeo de datos cliente principal
    if (this.dataService.getCompanyName()) {
      request.client.companyName = this.dataService.getCompanyName();
    }
    if (this.dataService.getDateEntryWork()) {
      request.client.dateEntryWork = this.dataService.getDateEntryWork();
    }
    if (this.dataService.getRucCompany()) {
      request.client.rucCompany = this.dataService.getRucCompany();
    }
    if (this.dataService.getProfession()) {
      request.client.profession = this.dataService.getProfession();
    }
    // Chequeo de datos Mancomunado
    if (this.dataService.getCompanyNameJoint()) {
      request.joint.companyName = this.dataService.getCompanyNameJoint();
    }
    if (this.dataService.getDateEntryWorkJoint()) {
      request.joint.dateEntryWork = this.dataService.getDateEntryWorkJoint();
    }
    if (this.dataService.getRucCompanyJoint()) {
      request.joint.rucCompany = this.dataService.getRucCompanyJoint();
    }
    if (this.dataService.getProfessionJoint()) {
      request.joint.profession = this.dataService.getProfessionJoint();
    }
    this.store.dispatch(LaborManagerCreateActions.getLaborManagerCreate({ request }));
  }

  setServiceData() {
    this.dataService.setWorkActivityTypeJoint(this.formData.controls['workActivityType'].value);
    this.dataService.setDateEntryWorkJoint(this.formData.controls['dateEntryWork'].value);
    this.dataService.setCompanyNameJoint(this.formData.controls['companyName'].value);
    this.dataService.setRucCompanyJoint(this.formData.controls['rucCompany'].value);
    this.dataService.setProfessionJoint(this.formData.controls['profession'].value);
  }

  activityChange() {
    const activityValue = this.formData.controls['workActivityType'].value;
    if (activityValue === 'null') {
      this.resetForm();
    } else if (this.accountType === 'CTS') {
      this.setFormRequired(activityValue);
    } else if (activityValue === activitiesCodes.DESEMPLEADO || activityValue === activitiesCodes.AMA_DE_CASA
      || activityValue === activitiesCodes.ESTUDIANTE || activityValue === activitiesCodes.JUBILADO) {
        this.setFormOptional(activityValue);
        this.showCompanyName = false;
        this.showRuc = false;
        this.showDate = false;
        this.showProfession = false;
        this.showSalaryCheck = false;
    } else if (activityValue === activitiesCodes.INDEPENDIENTE) {
      this.setFormOptional(activityValue);
      this.showCompanyName = true;
      this.showDate = true;
      this.showRuc = false;
      this.showProfession = false;
      this.showSalaryCheck = false;
    } else if (activityValue === activitiesCodes.FFAA) {
      this.formData = this._fb.group({
        workActivityType: [activityValue, Validators.required],
        dateEntryWork: [''],
        companyName: ['', Validators.required],
        rucCompany: [''],
        profession: [null]
      });
      this.showCompanyName = true;
      this.showRuc = true;
      this.showDate = true;
      this.showProfession = true;
      this.showOptionalCompanyNameLabel = false;
      this.showOptionalDateLabel = true;
      this.showOptionalProfessionLabel = true;
      this.showOptionalRucLabel = true;
      this.showSalaryCheck = false;
    } else if (activityValue === activitiesCodes.INFORMAL) {
      this.setFormOptional(activityValue);
      this.showCompanyName = true;
      this.showRuc = false;
      this.showDate = false;
      this.showProfession = false;
      this.showSalaryCheck = false;
    } else if (activityValue === activitiesCodes.DEPENDIENTE) {
      if (this.accountType === 'Ahorro') {
        this.formData = this._fb.group({
          workActivityType: [activityValue, Validators.required],
          dateEntryWork: [''],
          companyName: ['', [Validators.required]],
          rucCompany: ['', [Validators.required]],
          profession: [null]
        });
        this.showOptionalCompanyNameLabel = false;
        this.showOptionalRucLabel = false;
        this.showOptionalDateLabel = true;
        this.showOptionalProfessionLabel = true;
      } else if (this.accountType === 'Flex') {
        // Deposito de sueldo
        this.showSalaryCheck = true;
        this.formData = this._fb.group({
          workActivityType: [activityValue, Validators.required],
          dateEntryWork: [''],
          companyName: ['', [Validators.required]],
          rucCompany: [''],
          profession: [null],
          salaryCheck: [false]
        });
        this.showOptionalCompanyNameLabel = false;
        this.showOptionalRucLabel = true;
        this.showOptionalDateLabel = true;
        this.showOptionalProfessionLabel = true;
      }
      this.showRuc = true;
      this.showDate = true;
      this.showCompanyName = true;
      this.showProfession = true;
    }
  }

  checkYears(e) {
    if (Date.parse(this.formData.controls['dateEntryWork'].value) > Date.parse(this.today)) {
      this.dateInvalid = true;
    } else {
      this.dateInvalid = false;
    }
  }

  setFormOptional(workActivity = null) {
    this.formData = this._fb.group({
      workActivityType: [workActivity, Validators.required],
      dateEntryWork: [''],
      companyName: [''],
      rucCompany: [''],
      profession: [null]
    });
    this.showOptionalCompanyNameLabel = true;
    this.showOptionalRucLabel = true;
    this.showOptionalDateLabel = true;
    this.showOptionalProfessionLabel = true;
  }

  setFormRequired(workActivity) {
    this.formData = this._fb.group({
      workActivityType: [workActivity, Validators.required],
      dateEntryWork: ['', Validators.required],
      companyName: ['', Validators.required],
      rucCompany: ['', [Validators.required]],
      profession: [null, Validators.required]
    });
    this.showOptionalCompanyNameLabel = false;
    this.showOptionalRucLabel = false;
    this.showOptionalDateLabel = false;
    this.showOptionalProfessionLabel = false;
  }

  resetForm() {
    this.formData.controls['workActivityType'].patchValue(null);
    this.showCompanyName = false;
    this.showRuc = false;
    this.showDate = false;
    this.showProfession = false;
    this.showSalaryCheck = false;
  }
}

